module.exports = __webpack_public_path__ + "static/media/Stellar Ark Queen Headboard - 155 cm_Grey.3b88ce6e.png";